<template>
  <div
    class="flex flex-col items-center justify-center w-full py-12 px-4 text-center"
  >
    <div
      class="flex items-center justify-center mb-5"
    >
      <icon
        icon-name="no-orgRegister"
        style="width: 280px; height: auto;"
      />
    </div>
    <p class="max-w-md text-base text-romanSilver leading-relaxed">
      <span class="block">{{ title }}</span>
      <span v-if="subtitle" class="block mt-2">{{ subtitle }}</span>
    </p>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "NoOrgRegister",
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: "No posts have been created yet.",
    },
    subtitle: {
      type: String,
      default:
        "Once a post is created, it will automatically appear in this register.",
    },
  },
};
</script>
